import React from 'react';

const LevelUpV2 = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M14.9932 13.9927L11.9946 10.9941L8.99599 13.9927",
      stroke: "white",
      strokeWidth: "1.49929",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ React.createElement("path", { d: "M11.9951 11.4942V22.9888", stroke: "white", strokeWidth: "1.49929" }),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M14.2765 3.4205L16.0742 7.43144L20.4411 7.9043C22.5842 8.13635 23.4475 10.7911 21.8509 12.2394L18.5932 15.1945L19.494 19.5015C19.9355 21.6128 17.6744 23.2541 15.8038 22.18L14.996 21.7162V19.9874L16.5504 20.8798C17.2986 21.3094 18.203 20.6529 18.0264 19.8084L16.9499 14.6609L20.8436 11.1289C21.4823 10.5496 21.1369 9.4877 20.2797 9.39488L15.0577 8.82944L12.9083 4.0337C12.5553 3.24606 11.4371 3.24606 11.0841 4.0337L8.93468 8.82944L3.71275 9.39488C2.85552 9.4877 2.51016 10.5496 3.1488 11.1289L7.04255 14.6609L5.966 19.8084C5.78938 20.6529 6.69383 21.3094 7.44205 20.8798L8.99882 19.986V21.7148L8.18859 22.18C6.31802 23.2541 4.05691 21.6128 4.49846 19.5015L5.39922 15.1945L2.14148 12.2394C0.544887 10.7911 1.40827 8.13635 3.55135 7.9043L7.91826 7.43144L9.71594 3.4205C10.5985 1.4514 13.3939 1.45141 14.2765 3.4205Z",
      fill: "white"
    }
  )
);

export { LevelUpV2 };
//# sourceMappingURL=LevelUpV2.js.map
